import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
} from "reactstrap";
import classnames from "classnames";
import BasicProjectDetails from "./BasicProjectDetails";
import Milestones from "./Milestones";
import Tasks from "./Tasks";
import Notes from "./Notes";
import ActivityLog from "./ActivityLog";
import Loader from "pages/Separate/Loader";
import { useParams } from "react-router-dom";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import Credential from "./Credential";
import ProjectOverview from "./ProjectOverview";
import AddTask from "../common/AddTask";
import moment from "moment";
import { fetchData, FetchNodePostData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import SupportIndex from "pages/WorkModule/Support/Tickets/SupportIndex";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import configure from "../../../../../src/configure";
import axios from "axios";
import Swal from "sweetalert2";
import priorityOption from "../../../../";

const EditProject = () => {
  const [verticalActiveTab, setVerticalActiveTab] = useState("1");
  const [fixedSideTab, setFixedSideTab] = useState(false);
  const [isFreez, setIsFreez] = useState(false);
  const [addTask, setAddTask] = useState(false);
  const [addIssue, setAddIssue] = useState(false);
  const [projectTasks, setProjectTasks] = useState([]);
  const [assigned, setAssigned] = useState(null);
  const [title, setTitle] = useState("");
  const [estHours, setEstHours] = useState("");
  const [probability, setProbability] = useState("");
  const [priority, setPriority] = useState(null);
  const [description, setDescription] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);
  const [projectId, setProjectId] = useState();
  const [issueType, setIssueType] = useState("new");

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setAddTask(false);
        setAddIssue(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setFixedSideTab(window.scrollY > 68);
    };
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setVerticalActiveTab(tab);
    }
  };

  const params = useParams();
  const token = secureLocalStorage.getItem("auth_token");
  const [isLoading, setLoading] = useState(false);
  const [projectDetail, setProjectDetail] = useState({});
  const [projectType, setProjectType] = useState();
  const [assigneeOptions, setAssigneeOptions] = useState([]);

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const getProjectDetails = async () => {
    setLoading(true);
    try {
      const res = await fetchData(
        toggleLoading,
        `projectView/${params.id}`,
        token
      );
      if (res?.success) {
        setProjectDetail(res?.data?.project[0] || {});
        setProjectId(res?.data?.project[0]?.id);
        setProjectType(res?.data?.project[0]?.project_type);
      }
    } catch (error) {
      console.error("Error fetching project details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (verticalActiveTab === "1") {
      getProjectDetails();
    }
  }, [verticalActiveTab]);

  const setMaintenanceIssueType = (type) => {
    setIssueType(type);
  };

  useEffect(() => {
    const fetchDatas = async () => {
      const response = await fetchData(
        toggleLoading,
        "allProjectRelatedData",
        secureLocalStorage?.getItem("auth_token")
      );
      if (response?.success) {
        setAssigneeOptions(
          response?.data?.developers?.map((obj) => ({
            value: obj.id,
            label: obj.alias_name,
          }))
        );
      }
    };
    fetchDatas();
  }, []);

  const priorityOptions = [
    { value: 0, label: "Low" },
    { value: 1, label: "Medium" },
    { value: 2, label: "High" },
  ];
  const fetchTasks = async () => {
    const userId = localStorage.getItem("auth_id");

    const res = await axios.get(
      `${configure.nodeApi}/getMaintenanceTasks/${params?.id}`
    );

    if (res?.data?.status) {
      const formatted = res.data.data.map((task) => ({
        value: { ...task, original_id: task.id },
        label: task.title,
      }));
      setProjectTasks(formatted);
    }
  };

  useEffect(() => {
    if (issueType === "bug") {
      fetchTasks();
    }
  }, [issueType]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const user = localStorage.getItem("auth_id");

    // Validate required fields
    if (!title || !estHours || !probability || !assigned?.value) {
      Swal.fire({
        icon: "warning",
        text: "Please fill in all required fields (Title, Estimated Hours, Probability, Assigned To).",
      });
      return;
    }

    const data = {
      user_id: parseInt(user),
      project_id: projectId,
      title: title || null,
      estimation_days: estHours ? parseInt(estHours) : null,
      probability: probability ? parseInt(probability) : null,
      priority: priority !== null ? parseInt(priority) : null, // Ensure priority is handled
      assign: assigned?.value || null,
      description: description || null,
      task_type: issueType === "new" ? 1 : 2,
      task_id:
        issueType === "bug" ? selectedTask?.value?.original_id || null : null,
    };

    console.log("Submitting data:", data);

    try {
      const res = await FetchNodePostData(
        toggleLoading,
        "issuesMaintenance",
        token,
        data
      );

      // Check if response is valid
      if (!res) {
        throw new Error("No response received from the server.");
      }

      // Check if response contains data and status
      if (res?.data?.status) {
        Swal.fire({
          icon: "success",
          text: "Issue added successfully.",
        });
        setAddTask(false);
        setAddIssue(false);
        setTitle("");
        setEstHours("");
        setProbability("");
        setPriority(null);
        setAssigned(null);
        setDescription("");
        setSelectedTask(null);
        getProjectDetails();
      } else {
        throw new Error(res?.data?.message || "Failed to add issue.");
      }
    } catch (error) {
      console.error("Error submitting form:", error.message || error);
      Swal.fire({
        icon: "error",
        text: error.message || "An error occurred while submitting the form.",
      });
    }
  };

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 1200,
    }),
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title={"Work"} breadcrumbItem={"Edit Project"} />
          <Row className="py-4 shadow mb-3 bg-white me-0 d-flex justify-space-between align-items-center">
            <div className="col-md-10 d-flex justify-content-start align-items-center">
              <h4 className="mb-0">
                <b>Project Title - </b> {projectDetail?.project_name}
              </h4>
              <div className="ms-4 border-left border-primary ps-2">
                <h5 className="mb-0">
                  Total Allocated hrs:{" "}
                  <span className="text-primary">
                    {projectDetail?.total_hrs}
                  </span>
                </h5>
              </div>
              <div className="ms-4 border-left border-primary ps-2">
                <h5 className="mb-0">
                  Deadline Date:{" "}
                  <span className="text-primary">
                    {moment(projectDetail?.enddate).format("DD MMM, YYYY") ||
                      "-"}
                  </span>
                </h5>
              </div>
            </div>
            <div className="col-md-2 d-flex justify-content-end">
              <div className="d-flex align-items-center gap-3">
                {projectDetail?.project_type === 3 && (
                  <div className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="customSwitchsizemd"
                      className={`mb-0 f-15 ${
                        isFreez ? "text-success" : "text-danger"
                      }`}
                    >
                      {isFreez ? "UnFreeze" : "Freeze"}
                    </label>
                    <div className="form-switch form-switch-md">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitchsizemd"
                        onChange={(e) => setIsFreez(e.target.checked)}
                        checked={isFreez}
                      />
                    </div>
                  </div>
                )}
                {projectDetail?.project_type === 3 ? (
                  <a
                    onClick={() => setAddIssue(true)}
                    className="btn text-white btn-save btn-label"
                  >
                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                    Tasks/Issues
                  </a>
                ) : (
                  <a
                    onClick={() => setAddTask(true)}
                    className="btn text-white btn-save btn-label"
                  >
                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                    Task
                  </a>
                )}
              </div>
            </div>
          </Row>
          <Row className="justify-content-between d-flex align-items-top">
            <Col md="2" className="px-0">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3 ${
                  fixedSideTab ? "fixed-side-tab" : ""
                } h-100`}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => toggleVertical("1")}
                  >
                    Project Overview
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "7",
                    })}
                    onClick={() => toggleVertical("7")}
                  >
                    Basic Project Details
                  </NavLink>
                </NavItem>
                {projectDetail?.project_type !== 3 && (
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "2",
                      })}
                      onClick={() => toggleVertical("2")}
                    >
                      Milestones
                    </NavLink>
                  </NavItem>
                )}
                {projectDetail?.project_type === 3 ? (
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "3",
                      })}
                      onClick={() => toggleVertical("3")}
                    >
                      Tasks & Issues
                    </NavLink>
                  </NavItem>
                ) : (
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "3",
                      })}
                      onClick={() => toggleVertical("3")}
                    >
                      Task
                    </NavLink>
                  </NavItem>
                )}
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "4",
                    })}
                    onClick={() => toggleVertical("4")}
                  >
                    Notes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "5",
                    })}
                    onClick={() => toggleVertical("5")}
                  >
                    Activity Log
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "6",
                    })}
                    onClick={() => toggleVertical("6")}
                  >
                    Credential
                  </NavLink>
                </NavItem>
                {/* {projectDetail?.project_type === 3 && ( */}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "8",
                      })}
                      onClick={() => toggleVertical("8")}
                    >
                      Support Tickets
                    </NavLink>
                  </NavItem>
                {/* )} */}
              </Nav>
            </Col>
            <Col md="10 pe-0">
              <div className="bg-transparent mb-0" id="edit-project">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <ProjectOverview projectDetail={projectDetail} />
                  </TabPane>
                  <TabPane tabId="7">
                    <BasicProjectDetails
                      verticalActiveTab={verticalActiveTab}
                      projectDetails={projectDetail}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <Tasks
                      verticalActiveTab={verticalActiveTab}
                      toggleLoading={toggleLoading}
                      projectDetails={projectDetail}
                      assigneeOptions={assigneeOptions}
                    />
                  </TabPane>
                  <TabPane tabId="4">
                    <Notes
                      verticalActiveTab={verticalActiveTab}
                      toggleLoading={toggleLoading}
                      edit={true}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <Milestones
                      verticalActiveTab={verticalActiveTab}
                      toggleLoading={toggleLoading}
                      projectDetail={projectDetail}
                      edit={true}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <Credential
                      verticalActiveTab={verticalActiveTab}
                      projectDetail={projectDetail}
                      assigneeOptions={assigneeOptions}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <ActivityLog
                      projectDetail={projectDetail}
                      verticalActiveTab={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="8" className="support-tab-pane" style={{ marginTop: "-155px" }}>
                    <SupportIndex
                      verticalActiveTab={verticalActiveTab}
                      projectDetails={projectDetail}
                    />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className={`note-sticky-form ${addTask ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Add Task</h5>
              <button
                type="button"
                onClick={() => setAddTask(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  ×
                </span>
              </button>
            </div>
            <AddTask projectId={params?.id} />
          </ResizableBox>
        </Draggable>
      </div>

      <div className={`note-sticky-form ${addIssue ? "d-block" : "d-none"}`}>
        <Draggable
          onStart={(e) => {
            if (e.target.type === "radio" || e.target.tagName === "LABEL") {
              e.stopPropagation();
              return false;
            }
            return true;
          }}
        >
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0 mb-3">Add Issue/Bug</h5>
              <button
                type="button"
                onClick={() => setAddIssue(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  ×
                </span>
              </button>
            </div>

            <div className="p-0">
              <form onSubmit={handleSubmit}>
                <div className="">
                  <label className="form-label fw-bold">Issue Type:</label>
                  <div className="col-12 mb-3 mb-md-0">
                    <span className="me-4">
                      <input
                        type="radio"
                        id="new"
                        defaultChecked={true}
                        onChange={(e) =>
                          setMaintenanceIssueType(e.target.value)
                        }
                        name="type"
                        value="new"
                      />
                      <label htmlFor="new" className="ms-2">
                        New Development
                      </label>
                    </span>
                    <span>
                      <input
                        type="radio"
                        onChange={(e) =>
                          setMaintenanceIssueType(e.target.value)
                        }
                        id="existing"
                        name="type"
                        value="bug"
                      />
                      <label htmlFor="bug" className="ms-2">
                        Issue/Bug
                      </label>
                    </span>
                  </div>
                </div>

                {issueType === "bug" && (
                  <div className="">
                    <Label className="form-label" htmlFor="Select-task">
                      Select Task:{" "}
                    </Label>
                    <Select
                      placeholder="tasks"
                      className="basic-multi-select"
                      id="Select-task"
                      isMulti={false}
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={projectTasks}
                      value={selectedTask}
                      onChange={setSelectedTask}
                    ></Select>
                  </div>
                )}

                {(issueType === "new" || selectedTask) && (
                  <div
                    className="row gx-3 gy-3 mt-2"
                    style={{
                      maxHeight: "60vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {issueType === "bug" && selectedTask ? (
                      <div>
                        <div className="col-md-12">
                          <div className="row mb-2">
                            <div className="col-md-6 d-flex align-items-center">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              <span className="fw-bold me-1 text-purple">
                                Title:
                              </span>{" "}
                              {selectedTask?.label}
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              <span className="fw-bold me-1 text-purple">
                                Assigned:
                              </span>{" "}
                              {selectedTask?.value?.assign || "NA"}
                            </div>
                          </div>

                          <div className="row mb-2">
                            <div className="col-md-6 d-flex align-items-center">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              <span className="fw-bold me-1 text-purple">
                                Estimated Hours:
                              </span>{" "}
                              {selectedTask?.value?.estimation_days || "NA"} hrs
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              <span className="fw-bold me-1 text-purple">
                                Actual Hours:
                              </span>{" "}
                              {selectedTask?.value?.timer || "NA"} hrs
                            </div>
                          </div>

                          <div className="mb-2 d-flex">
                            <i className="mdi mdi-chevron-right text-primary me-1 mt-1"></i>
                            <span className="fw-bold me-1 text-purple">
                              Description:
                            </span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: selectedTask?.value?.description,
                              }}
                            />
                          </div>
                        </div>

                        <div className="row mt-4">
                          <div className="col-md-4 mb-3">
                            <label className="form-label">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Title"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="form-label">
                              Estimated Hours:
                            </label>
                            <input
                              type="number"
                              placeholder="Enter Estimated Hours"
                              className="form-control"
                              value={estHours}
                              onChange={(e) => setEstHours(e.target.value)}
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <label className="form-label">Probability %:</label>
                            <input
                              type="number"
                              placeholder="Enter Probability %"
                              className="form-control"
                              value={probability}
                              onChange={(e) => setProbability(e.target.value)}
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <Label
                              className="form-label"
                              htmlFor="priority-select"
                            >
                              Priority:{" "}
                            </Label>
                            <Select
                              id="priority-select"
                              placeholder="Select Priority"
                              classNamePrefix="select"
                              options={priorityOptions}
                              value={priorityOptions.find(
                                (opt) => opt.value === priority
                              )}
                              onChange={(option) => setPriority(option.value)}
                              styles={colourStyles}
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <Label
                              className="form-label"
                              htmlFor="member-select"
                            >
                              Assigned To:{" "}
                            </Label>
                            <Select
                              placeholder="Assignee"
                              className="basic-multi-select"
                              id="member-select"
                              classNamePrefix="select"
                              isMulti={false}
                              styles={colourStyles}
                              options={assigneeOptions}
                              value={assigned}
                              onChange={setAssigned}
                            ></Select>
                          </div>

                          <div className="col-md-12">
                            <label className="form-label">Description</label>
                            <CKEditor
                              editor={ClassicEditor}
                              data={description || "<p></p>"}
                              onReady={(editor) => {
                                console.log("Editor is ready:", editor);
                              }}
                              onChange={(event, editor) =>
                                setDescription(editor.getData())
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <label className="form-label">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </div>

                        <div className="col-md-4">
                          <label className="form-label">Estimated Hours:</label>
                          <input
                            type="number"
                            placeholder="Enter Estimated Hours"
                            className="form-control"
                            value={estHours}
                            onChange={(e) => setEstHours(e.target.value)}
                          />
                        </div>

                        <div className="col-md-4">
                          <label className="form-label">Probability %:</label>
                          <input
                            type="number"
                            placeholder="Enter Probability %"
                            className="form-control"
                            value={probability}
                            onChange={(e) => setProbability(e.target.value)}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <Label
                            className="form-label"
                            htmlFor="priority-select"
                          >
                            Priority:{" "}
                          </Label>
                          <Select
                            id="priority-select"
                            placeholder="Select Priority"
                            classNamePrefix="select"
                            options={priorityOptions}
                            value={priorityOptions.find(
                              (opt) => opt.value === priority
                            )}
                            onChange={(option) => setPriority(option.value)}
                            styles={colourStyles}
                          />
                        </div>

                        <div className="col-md-4">
                          <Label className="form-label" htmlFor="member-select">
                            Assigned To:{" "}
                          </Label>
                          <Select
                            placeholder="Assignee"
                            className="basic-multi-select"
                            id="member-select"
                            classNamePrefix="select"
                            isMulti={false}
                            styles={colourStyles}
                            options={assigneeOptions}
                            value={assigned}
                            onChange={setAssigned}
                          ></Select>
                        </div>

                        <div className="col-md-12">
                          <label className="form-label">Description</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={description || "<p></p>"}
                            onReady={(editor) => {
                              console.log("Editor is ready:", editor);
                            }}
                            onChange={(event, editor) =>
                              setDescription(editor.getData())
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}

                <div className="my-2 text-end">
                  <button type="submit" className="btn btn-save btn-label">
                    <i className="fas fa-save me-2 label-icon"></i>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  );
};

export default EditProject;
